import React from "react";

function Cookie() {
  return (
    <section className="bg-default text-light services-section" id="cookie-policy">
      <div className="container">
        {/* Page Header */}
        <div className="mb-5 text-center">
          <h1 className="text-accent-2 mb-3 fw-bold">Cookie Policy</h1>
          <p className="fst-italic">Last updated: 23/06/2025</p>
          <p className="lead">
            At <strong>ChatCGT LTD</strong>, we are committed to protecting your privacy and providing transparency about how we use cookies on our website.
          </p>
        </div>

        {/* Content Rows */}
        <div className="row gy-5">
          <div className="col-12">
            <h2 className="text-accent-2 mb-3">1. What Are Cookies?</h2>
            <p>
              Cookies are small text files stored on your device when you visit a website. They help remember your actions and preferences to enhance your experience.
            </p>
          </div>

          <div className="col-12">
            <h2 className="text-accent-2 mb-3">2. How We Use Cookies</h2>
            <p>We use cookies to:</p>
            <ul>
              <li>Ensure the website functions properly.</li>
              <li>Gather anonymous analytics to help us improve our site.</li>
            </ul>
            <p>We do not use cookies for advertising purposes.</p>
          </div>

          <div className="col-12">
            <h2 className="text-accent-2 mb-3">3. Types of Cookies We Use</h2>
            <div className="table-responsive">
              <table className="table table-dark table-bordered">
                <thead>
                  <tr>
                    <th>Cookie Type</th>
                    <th>Purpose</th>
                    <th>Duration</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><strong>Strictly Necessary Cookies</strong></td>
                    <td>Enable core functionality such as security and accessibility.</td>
                    <td>Session & Persistent</td>
                  </tr>
                  <tr>
                    <td><strong>Performance/Analytics Cookies</strong></td>
                    <td>Help us understand how visitors use our site by collecting anonymous data.</td>
                    <td>Persistent</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="col-12">
            <h2 className="text-accent-2 mb-3">4. Third-Party Cookies</h2>
            <p>
              We may use trusted third-party services like Google Analytics. For more information, please see{" "}
              <a href="https://policies.google.com/technologies/partner-sites" target="_blank" rel="noopener noreferrer" className="text-accent text-decoration-underline">
                Google’s Privacy & Terms
              </a>.
            </p>
          </div>

          <div className="col-12">
            <h2 className="text-accent-2 mb-3">5. Managing Your Cookies</h2>
            <p>
              You can adjust your cookie preferences at any time through our cookie consent banner or through your browser settings. For more help, visit{" "}
              <a href="https://www.allaboutcookies.org/" target="_blank" rel="noopener noreferrer" className="text-accent text-decoration-underline">
                www.allaboutcookies.org
              </a>.
            </p>
          </div>

          <div className="col-12">
            <h2 className="text-accent-2 mb-3">6. Changes to This Policy</h2>
            <p>
              We may update this policy occasionally to reflect changes in our practices or regulations. Please review this page regularly for the latest information.
            </p>
          </div>

        </div>
      </div>
    </section>
  );
}

export default Cookie;
